/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Display_New_Folder_Title_AttrInputs */



/**
* | output |
* | --- |
* | "New Folder" |
*
* @param {Explorer_Display_New_Folder_Title_AttrInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_display_new_folder_title_attr = /** @type {((inputs?: Explorer_Display_New_Folder_Title_AttrInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Display_New_Folder_Title_AttrInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Nouveau dossier")
	if (locale === "de") return /** @type {LocalizedString} */ ("Neuer Ordner")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nuova cartella")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Новая папка")
	if (locale === "es") return /** @type {LocalizedString} */ ("Nueva carpeta")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("新建文件夹")
	if (locale === "ja") return /** @type {LocalizedString} */ ("新しいフォルダ")
	if (locale === "hi") return /** @type {LocalizedString} */ ("नया फ़ोल्डर")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Nova pasta")
	return /** @type {LocalizedString} */ ("New Folder")
});